import { formatQueryParams } from '@utils/Format'
import con from '@services/connection'
import { endpoint } from '@modules/nps/constants/URL'

/**
 * Camada de API da pesquisa de NPS por módulo.
 *
 * Contrato do backend: HTTP 200 sempre, status real no corpo
 * (`{ status, message, value }`).
 *
 * DUAS PEGADINHAS DO `connection.js`, ambas silenciosas:
 * 1. `con.get(url, data)` entrega o `data` como CONFIG do axios, não como
 *    params — o objeto some e a request sai sem querystring. Por isso o filtro
 *    vai concatenado na URL, como em `apiCrmClientsTasks`.
 * 2. `post`/`patch` têm a assinatura `(url, data, ignoreErro, options)` — QUATRO
 *    parâmetros. Passar um quinto joga `options` para fora e o corpo vira
 *    `multipart/form-data`, transformando objeto aninhado em "[object Object]".
 *
 * Os resources de escrita declaram `add_argument('data', type=_json_dict_parser)`,
 * então o payload vai dentro de `data` como string JSON — o padrão de
 * `apiBackOfficeAccounts`.
 *
 * NENHUM erro daqui chega ao profissional: perder uma nota é ruim, mas mostrar
 * "erro ao enviar pesquisa" no meio de uma pesquisa que ninguém pediu é pior.
 * `ignoreErro = true` também evita que uma falha isolada dispare o fluxo de
 * sessão expirada do interceptor.
 */
function registrarFalha(operacao, error_) {
  // eslint-disable-next-line no-console
  console.warn('[nps] falha em ' + operacao + ':', error_ && error_.message)
}

class ApiNps {
  /**
   * @param {string} modulo chave do módulo (ex.: 'crm')
   * @returns {Promise<Object|null>} `{ elegivel, pergunta, rodape }` ou null
   */
  async elegibilidade(modulo, forcar) {
    try {
      const url =
        endpoint.elegibilidade +
        formatQueryParams(
          forcar ? { modulo: modulo, forcar: 1 } : { modulo: modulo }
        )
      const resposta = await con.get(url, null, undefined, true)
      return (resposta && resposta.value) || null
    } catch (error_) {
      registrarFalha('elegibilidade', error_)
      return null
    }
  }

  /**
   * Grava a nota. Chamada NO CLIQUE, não no envio do comentário.
   * @returns {Promise<string|null>} id da resposta, gerado pelo BANCO
   */
  async responder(payload) {
    try {
      const resposta = await con.post(
        endpoint.resposta,
        { data: JSON.stringify(payload) },
        true
      )
      return (resposta && resposta.value && resposta.value.id) || null
    } catch (error_) {
      registrarFalha('responder', error_)
      return null
    }
  }

  /**
   * Anexa o comentário a uma nota já gravada.
   * @param {string} id id devolvido por `responder`
   */
  async comentar(id, comentario) {
    if (!id) return null
    try {
      await con.patch(endpoint.comentario(id), { comentario: comentario }, true)
      return true
    } catch (error_) {
      registrarFalha('comentar', error_)
      return null
    }
  }

  /** Registra o fechamento no "x" — taxa de dispensa por módulo é sinal. */
  async dispensar(payload) {
    try {
      await con.post(endpoint.dispensa, { data: JSON.stringify(payload) }, true)
      return true
    } catch (error_) {
      registrarFalha('dispensar', error_)
      return null
    }
  }
}

export default new ApiNps()
